const ProductType = {
    LOAN: "loan",
    CREDIT: "credit",
}
export default ProductType
